// extracted by mini-css-extract-plugin
module.exports = {"fake_btn_disable":"index_fake_btn_disable_2_3ld"};